var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 16.1967 4.58521 19.7896 8.25 21.2731V14.3423C8.25 12.6216 9.42111 11.1216 11.0905 10.7043L15.0073 9.7251L13.1279 8.65118C12.7683 8.44567 12.6433 7.98753 12.8488 7.6279C13.0543 7.26826 13.5125 7.14331 13.8721 7.34882L17.3721 9.34882C17.7317 9.55433 17.8567 10.0125 17.6512 10.3721L15.6512 13.8721C15.4457 14.2317 14.9875 14.3567 14.6279 14.1512C14.2683 13.9457 14.1433 13.4875 14.3488 13.1279L15.4768 11.1539L11.4543 12.1595C10.4527 12.4099 9.75 13.3099 9.75 14.3423V21.7459C10.4732 21.9121 11.2263 22 12 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.4e7bdb1aa252e4d442c6a9baade7f539.svg";
export { ForwardRef as ReactComponent };